import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Medical from './views/Medical.vue'
import Investment from './views/Investment.vue'
import Policy from './views/Policy.vue'
import Social from './views/Social.vue'
import Latest from './views/Latest.vue'
import Register from './views/Register.vue'
import Tickets from './views/Tickets.vue'
import Buy from './views/Buy.vue'
import Soldout from './views/Soldout.vue'
import Checkout from './views/Checkout.vue'
import Sponsor from './views/Sponsor.vue'
import Schedule from './views/Schedule.vue'
import Partners from './views/Partners.vue'
import Contact from './views/Contact.vue'
import Newsletter from './views/Newsletter.vue'
import Workshops from './views/Workshops.vue'
import Speaker from './views/Speaker.vue'
import Speakers from './views/Speakers.vue'
import Login from './components/session/Login.vue'
import Update from './components/session/Update.vue'
import Forgot from './components/session/Forgot.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/pillar/medical',
      name: 'Cannabis And Medical Use',
      component: Medical,
    },
    {
      path: '/pillar/investment',
      name: 'Market And Investment',
      component: Investment,
    },
    {
      path: '/pillar/policy',
      name: 'Policy And Public Administation',
      component: Policy,
    },
    {
      path: '/pillar/social',
      name: 'Social Impact And Equity',
      component: Social,
    },
    {
      path: '/latest',
      name: 'latest',
      component: Latest,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: Tickets,
    },
    {
      path: '/buy',
      name: 'buy',
      component: Buy,
    },
    {
      path: '/soldout',
      name: 'soldout',
      component: Soldout,
    },
    {
      path: '/sponsor',
      name: 'sponsor',
      component: Sponsor,
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule,
    },
    {
      path: '/partners',
      name: 'partners',
      component: Partners,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/newsletter',
      name: 'newsletter',
      component: Newsletter,
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
    },
    {
      path: '/workshops',
      name: 'workshops',
      component: Workshops,
    },
    {
      path: '/speaker',
      name: 'speaker',
      component: Speaker,
    },
    {
      path: '/speakers',
      name: 'speakers',
      component: Speakers,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/update',
      name: 'update',
      component: Update,
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
    },
  ]
})
